import { Token } from '@uniswap/sdk-core'
import { tickToPrice } from 'lib/src'
import { TickProcessed } from 'hooks/usePoolTickData'
import JSBI from 'jsbi'
import { AllV3TicksQuery } from 'state/data/generated'

const PRICE_FIXED_DIGITS = 8

// Computes the numSurroundingTicks above or below the active tick.
export default function computeSurroundingTicks(
    token0: Token,
    token1: Token,
    activeTickProcessed: TickProcessed,
    sortedTickData: AllV3TicksQuery['ticks'],
    pivot: number,
    ascending: boolean
): TickProcessed[] {
    let previousTickProcessed: TickProcessed = {
        ...activeTickProcessed
    }
    // Iterate outwards (either up or down depending on direction) from the active tick,
    // building active liquidity for every tick.
    let processedTicks: TickProcessed[] = []
    for (let i = pivot + (ascending ? 1 : -1); ascending ? i < sortedTickData.length : i >= 0; ascending ? i++ : i--) {
        const tickIdx = Number(sortedTickData[i].tickIdx)
        const currentTickProcessed: TickProcessed = {
            liquidityActive: previousTickProcessed.liquidityActive,
            tickIdx,
            liquidityNet: JSBI.BigInt(sortedTickData[i].liquidityNet),
            price0: tickToPrice(token0, token1, tickIdx).toFixed(PRICE_FIXED_DIGITS)
        }

        // Update the active liquidity.
        // If we are iterating ascending and we found an initialized tick we immediately apply
        // it to the current processed tick we are building.
        // If we are iterating descending, we don't want to apply the net liquidity until the following tick.
        if (ascending) {
            currentTickProcessed.liquidityActive = JSBI.add(
                previousTickProcessed.liquidityActive,
                JSBI.BigInt(sortedTickData[i].liquidityNet)
            )
        } else if (!ascending && JSBI.notEqual(previousTickProcessed.liquidityNet, JSBI.BigInt(0))) {
            // We are iterating descending, so look at the previous tick and apply any net liquidity.
            currentTickProcessed.liquidityActive = JSBI.subtract(
                previousTickProcessed.liquidityActive,
                previousTickProcessed.liquidityNet
            )
        }

        processedTicks.push(currentTickProcessed)
        previousTickProcessed = currentTickProcessed
    }

    if (!ascending) {
        processedTicks = processedTicks.reverse()
    }

    return processedTicks
}
